import { memoize } from 'proxy-memoize';
import { ProjectStore } from '../store/projectStore';

export const getProjects = memoize((s: ProjectStore) => s.projects);

export const getFnSetProjects = memoize((s: ProjectStore) => s.setProjects);
